/**
 * @module ヘルプダイアログ共通コンポーネント
 */
var mixin = {
  data() {
    return {
      show: false,
    };
  },
  created() {
    this.$mount();
    document.body.appendChild(this.$el);
    this.show = true;
  },
  watch: {
    $browserBack(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.close();
        this.$browserBack = false;
      }
    },
    $route() {
      this.close();
    },
  },
  methods: {
    close() {
      this.show = false;
      setTimeout(() => {
        if (document.body.contains(this.$el)) document.body.removeChild(this.$el);
        this.$destroy();
      }, 200);
    },
  },
};

export default {
  mixins: [mixin],
  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    btnName: {
      type: String,
      required: true,
    },
    okAction: {
      type: Function,
      required: true,
    },
    url: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      okLoadFlag: false,
    };
  },
  /** @type {Methods} */
  methods: {
    /**
     * OKボタン押下時処理
     */
    ok() {
      this.okLoadFlag = true;
      this.okAction();
      this.close();
      this.okLoadFlag = false;
      if (this.url) this.router(this.url);
    },
    /**
     * 画面遷移処理
     * @param {String} url
     */
    router: function (url) {
      this.$router.replace({
        path: url,
      });
    },
  },
};
